import { inject, injectable } from "tsyringe";
import { map } from "rxjs/operators";
import { VoucherDownloadRepository } from "src/containers/documents-download/repositories/voucher-download/voucher-download-repository";
import { autoBind } from "src/shared/decorators/autobind";
import { Coupon, PgaPolicy, Voucher } from "src/shared/models";

@injectable()
export class VoucherDownloadService {
    constructor(
        @inject("VoucherDownloadRepository")
        private repository: VoucherDownloadRepository
    ) {}

    @autoBind
    download(
        policy: PgaPolicy,
        coupon: Coupon,
        userIdentity = window.userIdentity
    ): Promise<Voucher> {
        const payload = {
            category: policy.product.category,
            systemCode: policy.product.systemCode,
            policyId: policy.id.toString(),
            couponId: coupon.id.toString(),
            voucherId: coupon.voucherId,
            userIdentity,
        };
        return this.repository
            .download(payload)
            .pipe(map<object, Voucher>((json) => Voucher.fromJson(json)))
            .toPromise();
    }
}
